export const TRANSCRIPTPATHS = {
0:`<p>Navneet &amp; Anshul
  <br />
  It&#39;s beautiful to be able to put what I feel into words.
  <br />
  Do not give up.
</p>
<p>
  <br />
  SAURABH KAUSHAL
  <br />
  -&gt; Very neatly &amp; intricately done. Every pic has diversity &nbsp;&amp; individualism
  <br />
  Way to go.
</p>
<p>Sucheta Sharma
  <br />
  Surreal work with real instincts. Beautiful creations &amp; wonderful
  <br />
  spirit.
</p>
<p>LAKHWINDER SINGH KHALSA
  <br />
  &nbsp; &nbsp; &nbsp;awesome work. By Ranjan Really Loved it !
</p>
<p>VIKAS &amp; ANJALI
  <br />
  &nbsp; &nbsp;Reality check capturing day-to-day chores. Beautiful
  <br />
  work. Good luck !!
</p>
<p>Abhilash:
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp;Liked the paintings a lot. Esp. the colours of the skies in&nbsp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp;different settings :)
</p>
<p>Ragini &amp; Manika
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp;There&#39;s so much variety expressed just by one indi-
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp;vidual: its spectacular, shows what a creative &amp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp;open mind you possess.
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp;You&#39;re truly living up your life.
</p>
<p>
  <br />
  &nbsp;
</p>`,
1:`<p>Dr Richa Minach
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; Amazing work. Inspires me to try my hand at&nbsp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; painting some day.
</p>
<p>Dr. Priyanka Jaswal
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; I am speechless. &nbsp; Outstanding, Amazing, super.
</p>
<p>&nbsp; Surinder Pal Singh
  <br />
  &nbsp;&nbsp; &nbsp; &nbsp;Very Good Paintings. Keep it up.
</p>
<p>Dr Aabha Sharma
  <br />
  &nbsp; &nbsp; &nbsp; Nice Paintings. must approve the use and blend of colours
</p>
<p>Gunjan Saklani &nbsp; &nbsp; Really nice paintings
</p>
<br />
<p>Ishita Parmar &nbsp; &nbsp;Amazed by the imagination.&nbsp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Truly multitalented person!
</p>
<br />
<p>Kshiti Chauhan &nbsp; Intense colours, abstract flavours&nbsp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; work well with the subject Amazing :)
</p>
<p>Manish Negi &nbsp; &nbsp; &nbsp; &nbsp;Amazing Paintings, really Nice.
</p>
<p>Vinika Thakur &nbsp; &nbsp; &nbsp;Amazing
</p>
<p>Sameaul Mack (Artist) &nbsp;Very detailed work.
</p>
<p>Sundar ranjan &nbsp; &nbsp; &nbsp;Can&#39;t say in words. It&#39;s amazing
  <br />
  &nbsp;
</p>`,
2:`<p>SUKHWINDER SINGH
  <br />
  &nbsp;&nbsp; &nbsp;Very well done! Keep it up !!
</p>
<p>Harmanjeet Singh
  <br />
  &nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;Excellend work. Mak would benefit&nbsp;
  <br />
  &nbsp;&nbsp; &nbsp;with ur paintings. God bless you
</p>
<p>Mahesh Thakur - Great - Love the Alley moonshine-Super
</p>
<p>
  <br />
  Sambhav Sharma: The sense of dimension of remarkable.
  <br />
  &nbsp;&nbsp; &nbsp;Color tones and hues are lovely.
</p>
<p>Pratesh Sharma: It was a very lively experience&nbsp;
  <br />
  &nbsp;&nbsp; &nbsp;seeing all these masterpieces.
</p>
<p>Mahinder Sharma. It&#39;s been an awesome experience
  <br />
  &nbsp;to be here. Especially description of different&nbsp;
  <br />
  city was remarkable
</p>
<p>Manish Paragli. lovely paintings. Detailing done
  <br />
  very nicely. lovely use of colours. Keep up&nbsp;
  <br />
  the good work.
</p>
<p>Parika Bhatt&nbsp;
  <br />
  &nbsp;&nbsp; &nbsp;Very nice outstanding beautiful paintings&nbsp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; no words to describe very nice
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; appriciated work
</p>
<p>Tarika Bhatt &nbsp; &nbsp; Incredible.
</p>`,
3:`<p>Nice works especially a view of forest valley &amp; realistic paintings. Keep it up
  <br />
  &nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;with best wishes
  <br />
  &nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;Dr Amit Kumar
  <br />
  &nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;Shimla
</p>
<p>Awesome &amp; different work ever seen
  <br />
  &nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;All the best for future
  <br />
  <br />
  <br />
  <br />
</p>
<p>The beauty if the exceptional paintings can
  <br />
  not be explained in workds I would like you
  <br />
  to continue your work forever. All the
  <br /> best &amp; Regards
</p>
<p>&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;Dr Manoj Ranjan (IGMC)&nbsp;
  <br />
  <br />
  EXTRAORDINARY WORK, SIR ....
  <br />
</p>
<p>&nbsp;&nbsp; &nbsp;  &nbsp; &nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp;  &nbsp;  &nbsp;  &nbsp;GEETA RAM VERMA
  <br />
  <br />
</p>
<p>All these paintings seems to be photographs.<br/> The paitence, persevarance, imagination present<br /> in all these is amazing. God bless the<br />painter and he continues to do this work
  <br />
    &nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;26/11/2019<br />
    &nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;Dr Ramesh Sharma<br />
      &nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;VIDYAPEETH, SHIMLA<br />
</p>`,
4:`<p>
  Amazing work of art. Each one is exceptional. May</br>you achieve greater heights in this filed. God bless.
  <br />
  &nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;Sandhya Sharma
  <br /><br />
</p>
<p>Different Themes! &nbsp;&nbsp; Excellent work by the<br />young artist. I wish him success in future
  <br />
  &nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;Anita Pandey<br /><br />
</p>
<p>Unique work; Nice play with light and shadow.
  <br />
  Wish you all the best in life.
  <br />
  &nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;Karunesh
</p>
<p>Rare themes, originality, life abd happenings around especially<br />excellent colour background __________ superb<br /><br />
</p><br /><br /><br />
<p>Amazing paintings, nice to see sucha wonderful<br />work
</p>
<p>&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Jyoti Chaurasia
</p>
<p>Very Nice work done on detailing of each &amp; every<br />aspect. Amazing work
</p>
<p>&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;ATUL TAGRA
</p>`,
5:`<p>Painter to melodies by Sh Suryaranjan are really worth<br />admiring specially&nbsp;Varanasi Ghat and a scene in dusk<br/> and .................. the painting especially among<br />in Kullu is very admirable<br /><br/>
 &nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;The Mall Shimla H P
 &nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;24th Nov 2016<br/>
</p>
<p>Very nice creative thinking art done by<br />Mr Surya Ranjan Shandil. All paintings are<br />real looking and excellent
  <br /><br />
  GOD BLESS YOU
  <br /><br />
</p>
<p>Paintings are really nice
</p>
<br />
<p>Paintings are really outstanding
</p>
<p>Bharatiya Nagron ka Sundar Drisheya
</p>
<br/>
<p>Nice Paintings making U feel at home
</p>
</br>
<p>Nice, but not very nice
</p>`,
6:`<p>Everything is understandable except the Desert<br />painting need to put mind<br />if person who is watering.
</p>
<p>Paintings are really awesome
</p>
<br/>
<p>
  <br />
  Amazing Paintings &amp; a must watch. Liked it
</p>
<br />
<p>Nice Paintings and Picture I like it
</p><br />
<p>Paintings were nice and originial
</p><br />
<p>Nice Paintings&nbsp;
</p>
<p>
  <br />
  <br />
  Excellent. Some real work showing
  <br />
  himachal
</p>
<p>Excellent work
</p>
<p>Ankush
</p>`,
7:`<p>Good expression of thoughts through colours especially
  <br />
  vegetables vendors , sunflowers &amp; nako lakes&nbsp;
  <br />
  Great work
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Des Raj Thakur
  <br />
  &nbsp;
  <br />
  Ati uttam&nbsp;
</p>
<p>Indeed Beautiful. detailing is
  <br />
  wonderful. great&nbsp;
  <br />
  God Bless
</p>
<p>
  <br />
  It was just amazing to visit this exhibition.I am&nbsp;
  <br />
  feeling so wonderful by watching this type of art
  <br />
  work &amp; talent of the artist. I am feeling so wonderful.
  <br />
  It is just a good work. Superb.. ..!
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;kriti ..
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
  <br />
  &nbsp;Paiting &nbsp;is &nbsp;very &nbsp;beautiful.
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;from &nbsp; Ravinder
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Chandigarh.
  <br />
  Amazing work_ keep it up&nbsp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Dr H.K-Thakur
  <br />
  <br />
  Grete work done. Injoyed &nbsp; Vipasha.
</p>
<p>Excellent work, loved it&nbsp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;S Jaggi
</p>`,
8:`<p>
  These paintings &nbsp;collection &nbsp;are &nbsp;very
  <br />
  &nbsp; cool. &nbsp; Good &nbsp;art &nbsp;work
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Kawal
</p>
<p>
  <br />
  Lovely concept, a lot of things we capture in our
  <br />
  day today lives have been&nbsp;put on the canvas...very
  <br />
  offbeat &amp; great work!
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Priyanka
</p>
<p>
  <br />
  very nice work keep it up. Good luck&nbsp;
  <br />
  &nbsp; &nbsp;these paintings &nbsp; Seems &nbsp; pretty &nbsp;nice
  <br />
  &nbsp; &nbsp; &nbsp;we love them &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
</p>
<p>Beautiful work loved the blending of colours and
  <br />
  correct uses of brushes with full knowledge of
  <br />
  coloursscheme.Congratualation
</p>
<p>
  <br />
  I &nbsp;liked &nbsp;the painting &nbsp;specially &nbsp;about
  <br />
  Nature....!!!
</p>
<p>
  <br />
  my hobby i salso painting &nbsp;and I loved this
  <br />
  very much . &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Himanshu
</p>
<p>
  <br />
  Lovely paintings , describing &nbsp;nature at its best
</p>`,
9:`<p>Amazing Art - &nbsp;Lots to say&nbsp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Abhishek singh
</p>
<p>Awesome works, very realistic ,
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Shabnam
</p>
<br />
<p>very Nice &nbsp;
</p>
<p>all painting are so beautiful
</p>
<p>All art work is excellant &nbsp; V sharma
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Shimla
</p>
<p>All the paintings are very lively and realistic .
  <br />
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
  <br />
  <br />
  Art the best way to express the feelings of heart
  <br />
  let&#39;s come &nbsp;and exposes the feling&#39;s of heart .
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
</p>
<p>Wonderful Paintings with deep meaning and
  <br />
  &nbsp; &nbsp;wonderful &nbsp;thinkings. &nbsp; &nbsp;Proud to have&nbsp;
  <br />
  &nbsp;such a nyc &nbsp;thinking &nbsp;. &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Asmita
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Raipur,cg .
</p>
<p>
  <br />
  Nice Paintings &nbsp; &nbsp;&nbsp;
</p>`,
10:`<p>
  Great work.It seems the artist has captured the soul and
  <br />
  essence of India. cheers! &nbsp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;- Akhil Kashyap.
  <br />
  &nbsp;
  <br />
  very best paintings &nbsp; &nbsp; &nbsp; -Raju lal
</p>
<p>Best of it s kind - Thank you &nbsp;. &nbsp;&nbsp;
  <br />
  very beautiful paintings - &nbsp; M Negi
  <br />
  &nbsp;&nbsp;
  <br />
  Art is the music of heart .You&#39;ve done a great&nbsp;
  <br />
  job. Please Keep it up! &nbsp;&nbsp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Vibha Sharma
</p>
<p>All the Paintings adorable &nbsp; . we all enjoy &nbsp;all the paintings.
</p>
<p>
  <br />
  each paintings shows different shades and can take
  <br />
  us to different sequence of colors &nbsp;... loved the&nbsp;
  <br />
  paintings .
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; Manisha.
</p>
<p>&nbsp; You&#39;ve brought each painting come to life .I was
  <br />
  really stunned with the sunset in Shimla painting.
  <br />
  &nbsp; Greatt job man!!
</p>
<p>&nbsp;Each painting has been given natural touch.
  <br />
  &nbsp; seems to be reality . More over the painting r
  <br />
  &nbsp;at sunset at &nbsp; Shimla &nbsp; has natural &nbsp; &nbsp; touch
  <br />
  &nbsp; &nbsp;along with the Solan Bazar .
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; K Thakur
  <br />
  &nbsp;
</p>`,
11:`<p>&nbsp; &nbsp; Really commenable and unamazable
  <br />
  efforts put by Surya Ranjan . The days are
  <br />
  not far away,the almighty Shall award your
  <br />
  tireless efforts.
  <br />
  &nbsp; &nbsp;with love and god wishes.
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Veena Sharma
</p>
<p>&nbsp; Nice Work &nbsp;.
</p>
<p>&nbsp; &nbsp;Beautifully painted the &nbsp;nature &nbsp; I liked all the
  <br />
  paintings.
</p>
<br />
<p>&nbsp;It was really Beautiful experience, And the paintings&nbsp;
  <br />
  were &nbsp;marvelous
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;trisha.
</p>
<p>&nbsp;It was really beautiful experience and the&nbsp;
  <br />
  &nbsp; &nbsp; Paintings &nbsp;was very realistic &nbsp;.
</p>
<p>
  <br />
  &nbsp; Great collection of good vibes. &nbsp; ANKIT NAGA
  <br />
  &nbsp; very &nbsp;good &nbsp; &nbsp; &nbsp; &nbsp; Inder Singh&nbsp;
</p>
<br />
<p>
  &nbsp; &nbsp;Very great collection &amp; good paintings&nbsp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
  <br />
  &nbsp; &nbsp;Very Good &amp; Nice &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Jain (Gaya)
</p>
<p>&nbsp; &nbsp;Very Good, &amp; fantastic,awesome......etc&nbsp;
</p>`,
12:`
<p>&nbsp;
  &nbsp;Very good work &nbsp;and presentation&nbsp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Mrs. Chander
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Bishop Cottor school.
</p>
<p>
  <br />
  &nbsp;It was &nbsp;nice..
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - Mukesh Kumar
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; H.P.U
</p>
<p>&nbsp; Loved the &quot;Apple orcharder&quot;- Jyoti &amp; Divya .
  <br />
  &nbsp;
  <br />
  &nbsp; The new born bady was very attractive - Divya &amp; Jyoti.
</p>
<p>&nbsp;Very good paintings.I liked them.
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -Pradyum Sharma
</p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;- IV-A
</p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -St.Edwards School
</p>
  <br />
<p>&nbsp; The best artwork &nbsp; &nbsp;I&#39;ve &nbsp;ever &nbsp;seen ....
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Agreema Justa
  <br />
  <br />
  &nbsp;The Artist give a life in Picture&nbsp;
</p>
<p>&nbsp;Really enjoyed admiring the beautiful paintings
  <br />
  &nbsp;esp. the one inspired &nbsp; &nbsp; from a &nbsp; Scene of&nbsp;
  <br />
  Sholay movie &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Akshita
</p>`,
13:`<p>
  The work where Child is born &nbsp;Its Amazing&nbsp;
  <br />
  <br />
  <br />
  &nbsp;
  <br />
  Very good paintings . Love It &nbsp; &nbsp;sambhav sood&nbsp;
  <br/>
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;class= VIII&nbsp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; A H S
</p>
<p>
  <br />
  &nbsp;
  <br />
  Very good and original description &nbsp;of
</p>
<p>&nbsp; events .
</p>
<p>&nbsp;Very good painting &nbsp;. &nbsp;Abhay
</p>
<p>&nbsp;Beautiful &nbsp;painting&nbsp;
</p>
<p>Awesome !&nbsp;
</p>
<br />
<p>The works are beautiful, the subject matter is&nbsp;
  <br />
  interesting &nbsp;and &nbsp;you&#39;ve successfully brought
  <br />
  life to the &nbsp; canvas.The colours
  <br />
  in your works, are personally what I
  <br />
  liked .
  <br />
  Best of luck for ue future
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; -Pankaj Singh
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Deptt of visual Arts &nbsp;,HPU
</p>`,
14:`
<p>
  WONDERFUL &nbsp;hai &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Vasu/Shorya
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Pratyush/
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Priyanshu
</p><p>
  <br />
  Bonfire film sholay &nbsp; . superb
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Ajay
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Tanmay
</p>
<p>
  <br />
  &nbsp; AWSOME | EMOSWA
  <br />
  &nbsp; &nbsp; &nbsp;OPTICALLY ACTIVE COMP.
</p>
<p>
  <br />
  &nbsp;That whale!! Truly Amazing &amp; Those monkey&#39;s
  <br />
  &nbsp; truly funny!! And the most amazing one;&nbsp;
  <br />
  &nbsp; &quot;The sholay waala scene&quot; .
</p>
<br />
<p>&nbsp;The paintings were really beautiful and &nbsp;mesmerizing
  <br />
  &nbsp;and breathtaking . &nbsp; &nbsp;You give us an inspiration to&nbsp;
  <br />
  &nbsp;follow our Dreams &amp; Passion.
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Chandrika Thakur
  <br />
  &nbsp;We really &nbsp;too loved the paintings &nbsp; &nbsp; &nbsp; &nbsp; Shivani Sharma
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Manikaa Aluwahlia
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Jasmin Saret&nbsp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Shivam Rai
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Akansksha Sharma
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Shraddha Angra
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Anamika Sharma
</p>`,
15:`<p>&nbsp;Amazing A great work &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Akriti
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Himani
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Raghav
  <br />
  &nbsp;Really Appreciable &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Somya &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Thakur
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
</p>
<p>&nbsp;Really Appreciable , we loved these painting &nbsp;Mitul Chauhan
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Navneet Thakur&nbsp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Bodh Rej
</p>
<br />
<p>&nbsp;Nice work , appriciate the effort. &nbsp; &nbsp; &nbsp;(Himachal Watcher)
</p>
<p>* Kawaii &nbsp;, mind blowing &nbsp;, &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Anchal Kapoor
  <br />
  &nbsp; Really &nbsp;hard work is peeping out of &nbsp; &nbsp; Jaya Sharma
  <br />
  &nbsp; &nbsp; The paintings &nbsp;, very nice &nbsp;, &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Anjali Kedarta
  <br />
  &nbsp; &nbsp; &nbsp;awesome&nbsp;:) *
</p>
<p>
  <br />
  &nbsp;Akshay &nbsp; &nbsp; &nbsp; &nbsp;-: &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;unforgetable painting
</p>
<p>&nbsp;So Beaut of himachal &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; S.N. Dogra
  <br />
  &nbsp;I like it
  <br />
  &nbsp;Really Amessing Painting .
  <br />
  &nbsp;
</p>
<p>Awesome! Simply great art . &nbsp;keep it up .
</p>`,
16:`<p>&nbsp; Exceptional , Exciting ,Extraordinary&nbsp;
  <br />
  &nbsp; Lovely paintings with oil on
  <br />
  &nbsp; canvass . Liked bonfire inspired &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Er. AtulGarg.
  <br />
  &nbsp; from Sholey : Mehbooba &quot;o&quot; Mehbooba &nbsp; &nbsp; &nbsp; &nbsp; Kasumpti;Shimla-9
  <br/>
  <br/>
</p>
<br />
<p>&nbsp; Amazing work! we were totally
  <br />
  &nbsp; mesmerized &nbsp; by &nbsp;your work. &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Ridhi Rathore
  <br />
  &nbsp; So beautiful! we really appericiat &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Parul Mehta
  <br />
  &nbsp; &nbsp; your &nbsp;hard &nbsp;work &nbsp;&amp; devotion
</p>
<br/>
<p>
  <br />
  &nbsp; &nbsp; Very realistic paintings. &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Vijit Dua (8th class)
</p>
<br/>
<p>&nbsp; &nbsp; so beautiful painting &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Priya Thakur
</p>
<p>&nbsp; &nbsp; Amazing &nbsp;&amp; all painting seems to &nbsp; &nbsp; Avani Sharma
  <br />
  &nbsp; &nbsp; &nbsp;be natural &nbsp;. Mind blowing paintings&nbsp;
</p>
<p>&nbsp;&nbsp;
  <br />
  &nbsp; &nbsp; Awesome and appreciable &nbsp; &nbsp; &nbsp;Neha Thakur.
</p>
<p>&nbsp; &nbsp; Not upto the price &nbsp; &nbsp; &nbsp; &nbsp; Raghav Haryana &nbsp;(Kaithal)
</p>
<p>&nbsp; &nbsp;-Nice +,Good &nbsp;that&#39;s it &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Shiv&nbsp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; (Vidyapeeth)
</p>`,
17:`
<p>&nbsp;Awesome painting &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Mitali  &nbsp;&nbsp;<br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Vidyapeeth<br />
  &nbsp;Really beautiful paintings &nbsp; &nbsp; &nbsp;Vipasa 
</p>
<p>&nbsp;Adorable paintings ,Really beautifull ,Great work
<br/>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Shailja Gupta&nbsp; &nbsp; Vidyapeeth  &nbsp; Onam gupta
</p>
<p>Awesome paintings &nbsp; &nbsp; Akshatand Agastya Akshat Agastya
</p>
<p>Awesome and beautiful paintings &nbsp;Kutica 
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Vidyapeeth
  <br />
  Really Awesome ,Great work &nbsp; &nbsp; &nbsp; Nikita
</p>
<p>Very good paintings &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Gautam&nbsp;
</p>
<p>Very nice beautiful paintings &nbsp; &nbsp; &nbsp; &nbsp;  &nbsp; &nbsp; Parika Bhatt&nbsp;
</p>
<p>Incrediable &nbsp;Paintings &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;A Bhatt
</p>
<p>Well chaired and well attended LOL &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
</p>
<p>Incredible you are and yours paintings too 
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; Akshita Dhiman, Sakshi, Kritika, Shweta, Akshita 
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Vidyapeetians
</p>
<p>
  Realistic and Magnificent Pictures &nbsp; &nbsp; &nbsp; &nbsp; Sakshi Banyal
</p>
<p>
  Nice realistic art if you use Liquid medium (specially
  <br/>tube 200 ml one ) from Klineor &amp; Newton,your paintings 
  <br />will dry within a week and not crack paint film
  <br /> even if painted thick.Also when you are taking so
  <br/ >much effort to paint realistic,then use artist 
  <br />Winsor &amp;Newton &amp; not student oil paints. Good art.
</p>`,
18:`<p>Good luck !!! for future &nbsp; &nbsp;&nbsp;
</p>
<p>&nbsp;Very Beautiful &amp; Real looking paintings&nbsp;
</p>
<br />
<p>One of the paintings .I like most is the painting<br/>
show the love between father &amp; his baby.<br />
It's really amazing .
</p>
<p>&nbsp;The paintings are wonderful .Ojaswi &nbsp; &nbsp;
  <br />
  &nbsp;No comment.
</p>
<br />
<p>&nbsp;Awsm ,fantastic, the paintings are unbelivable no words !!!&nbsp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; well done
</p>
<p>&nbsp;I &nbsp;like your all &nbsp;paintings .No words to<br/>say . Superb.!...
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Anjali Thakur&nbsp;
</p>
<p>&nbsp;This exibition was a great inspiration for<br/>now I am looking forward myself to make<br/>such beautiful paintings like this.
</p>
<p>Inspiring ....
</p>`,
19: `<p>
  Enough you want to kill, &nbsp; &nbsp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
  <br />
  Nice &nbsp; Diversified &nbsp; &nbsp; Work
</p>
<p>
  <br />
  &nbsp;Beautiful paintings Ranjan :)&nbsp; &nbsp; &nbsp; Rammie Sood&nbsp;
</p>
<p>&nbsp;Amazing Paintings &nbsp;Ranjan.
</p>
<p>All paintings are just awsome &nbsp;Tiya&nbsp;:)
</p>
<p>Your &nbsp;work&nbsp;
  <br />
  Evokes the hills beautifully
  <br />
  &nbsp;
  <br />
  All the best for future &nbsp; - Er guru
  <br />
  &nbsp; &nbsp; Nice
</p>
<br />
<p>Wonderful work of impressionism along
  <br />
  with some pop art mixture,specially
  <br />
  the Solan Market &amp; Shoolini &nbsp;Fair . &nbsp; Aditya Singh Thakur
  <br />
  My Favorouts were Monkeys,Night in &nbsp; 
  <br />
  &nbsp; Mountains &amp; Night in Mountains &amp;Orchards .
  <br />
  Excellent, (except the Artist signatures which I dont like).
</p>
<p>
  Very realistic &nbsp;and wonderful work &nbsp;.
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Ishita&nbsp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Kapoor &nbsp;.
</p>`,
20:`<p>
  Nice &nbsp;work .
  <br />
  &nbsp;
</p>
<p>Great work done by an IITian&nbsp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
</p>
<br />
<p>Awesome &nbsp;work ,great imagination &nbsp;.I loved all
  <br />
  
  of them , specially scene&nbsp;from &#39;sholey&#39; &nbsp;awesomeee...
</p>
<p>
  <br />
  Good work,with great imagination .
</p>
<p>A  Great Work
  <br />
  &nbsp;
</p>
<p>Nice Paintings. &nbsp;I liked all, Needs alot
  <br />
  of sense of art. Good Work. Keep it
  <br />
  up. God Bless you and shower all
  <br />
  his blessings on you, So you can paint more
  <br />
  and more
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Top floor
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Chief Fire office building
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;stokes place, JAKHOO , Shimla&nbsp;
</p>`,
21:`<p>&nbsp;
  Differently made adorable nice &nbsp;work
  <br />
  &nbsp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Tata Steel, Jamshedpur
  <br />
  &nbsp;
  <br />
  &nbsp; Adorable, and have fortunate to
  <br />
  &nbsp; &nbsp;have u as my partner . &nbsp; &nbsp; &nbsp; &nbsp; Tarika Bhatt
  <br />
  &nbsp;
  <br />
  &nbsp;
  <br />
  &nbsp;Beautiful work; would like see more in
  <br />
  &nbsp; &nbsp;future&nbsp;
  <br />
  &nbsp; &nbsp; &nbsp;Hats off ! to th artist
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Ayushi
</p>
<p>&nbsp;Great work done ! All the
  <br />
  &nbsp; &nbsp; &nbsp; very best . &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Vijay
</p>
<p>Very nice paintings from Kalandi&nbsp;
</p>
<br />
<p>
  <br />
  &nbsp;All the paintings ar fabaulous &amp; gorgeous
  <br />
  <br />
  <br/>
  </p>
<p>
  <br />
  Gr8
</p>`,
22:`<p>
  The paintings are really wonderful, especially the one&nbsp;
  <br />
  of the mountains &nbsp;(first one) and wedding in&nbsp;
  <br />
  hills. Nice work!
</p>
<p>
  <br />
  <br />
  <br />
  Adorable &amp; Excellent Portrait
  <br />
  Very&nbsp;lucky
</p>
<p>
  <br />
  Great paintings with artistic beauty.
</p>
<p>very realisitic paintings.
</p>
<br/>
<p>very nice and beautiful paintings
</p>
<p>Picturesque ...... of beautiful painting
</p>
<p>The paintings &nbsp;are lovely! keep up the good work.
  <br />
  I hope to see &nbsp; more of &nbsp;these year &nbsp;after year
  <br />
  &nbsp;God bless! &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Vibhuti
</p>
<p>THE USES OF COLOURS ARE BEAUTIFUL, JOY &amp;
  <br />
  LOVE ARE SHOWN WITH AFFECTION &nbsp;Best of
  <br />
  &nbsp;luck &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Lalit&nbsp;
  <br />
  &nbsp;First time seen paintings on&nbsp;practical aspects
  <br />
  &nbsp;of life .
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
</p>
`,
23:`<p>
  <br />
  -&gt; Beautiful .... Harkuch !!!
</p>
<p>-&gt; Nice Monekys !!! Great work done :) *
</p>
<p>-&gt; Tanmay
  <br />
  -&gt; Sarthak
  <br />
  -&gt; Angel
</p>
<p>
  <br />
  <br />
  # Really remarkable canvas. Silence on walls can speak
  <br />
  lot many things and that's what the paintings have been
  <br />
  able to convey. Superb job. Well done
  <br />
  Really liked the one with baby. Keep going and
  <br />
  make your own horizon. Best wishes
</p>
<p>Alok
</p>
<p>
  <br />
  # Very unique style on oil colours. Humourous and&nbsp;
  <br />
  thoughtful. Best Wishes.
</p>
<p>
  <br />
    <br />
  # 22G&nbsp;
</p>`,
24:`
<p>Nice painting&#39;s and reasonable price ... Great
  <br />
  &nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp; Work
</p>
<p>So Nice But cost is heavy ... thank you
</p>
<p>Very Nice .... Osm&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;thank you
  <br />
  &nbsp;&nbsp; &nbsp;&amp; Great Work
</p>
<br/>
<br/>
<p>Great Work Keep shining
</p>
<p>Wow great painting, Extremely Splinded
  <br />
  Experience. Superb work by Painter
</p>
<br/>
<br/>
<br/>
<p>
  <br />
  Nice painting &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;thanku Ravi Kiran
</p>
<p>Eye Opener !
</p>
<br/>
<p># Nice collection of hard work put by
  <br />
  painter. Paintings are very lively
</p>
<p># Keep it up Ranjan. No caption painting is Awsm. Very
  <br />
  Realistic and beautiful. Truly wow
</p>`,
25:`
<p>
  <br />
  -&gt; Good Work&nbsp;
</p>
<p>- Very good work
  <br />
  &nbsp; Great paintings
</p>
<p>- Need to improve
  <br />
  &nbsp;&nbsp;
  <br />
  &nbsp; Very graceful I love it.
  <br />
  &nbsp;&nbsp; &nbsp;I love Shimla !!
</p>
<p>- They seem like photographs when you
  <br />
  &nbsp; see at a distance !
</p>
<p>- Excellent
</p>
<br/>
<p>- It was amazing watching these fantastic
  <br />
  drawing. Learned something !
</p>
<p>- Amazing artist
</p>
<p>- wonderful Paintings !
</p>
<p>- Incredible
</p>
<p>- Awesome &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; (Seeing the Kanyakimari painting&nbsp;
  <br />
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp;remembered by visit there)
</p>
<p>- Insane Mayank
  <br />
  &nbsp; Ansh &nbsp;MAyAnk
</p>`,
26:`
<p>
  Excellent work &nbsp; Keep it up !! !!
</p>
<p>- Incredible
  <br />
  - Awesome collection of beautiful paintings.
  <br />
  - Wish you All the Best
</p>
<p>Nice one
  <br />
  - Superb painting
</p>
<p>- Punit Sharma
  <br />
  All paintings are good showed Natural Beauty
  <br />
  Amazing Guru
</p>
<br />
<p>Incredible work, keep it up &nbsp; &nbsp;- Anglica, Averi
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; :) &nbsp; &amp; Diksha
</p>
<p>Abhivyaktiyon ki baarikiyon par kaam ki zaroorat &nbsp; Sunil Grover
  <br />
  Shrest kaarye &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Theog
</p>
<p>* I liked your work with beautiful
  <br />
  title. Deep meaning ....
  <br />
  &nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;Priya
</p>
<br />
<p>Very Aws painting I love it very much.
  <br />
  &nbsp;&nbsp; &nbsp;Anshit
</p>
<p>#Awsm paintings #Expert painter. #love them
</p>`,
27:`<p><br />Harkuch beautiful, Nice .......
</p>
<p>Its good to see paintings which have a deep concept. They
  <br />
  potray many things. Its really adorable beautiful.
</p>
<p>
  <br />
  Some of the works of yours have a flavour of their own
  <br />
  Specially the monkeys
  <br />
  &nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; (Ankit)
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 2017/10/12
</p>
<br />
<p>nice paintings especially the maori .... awesome
</p>
<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Mrs Vedika&nbsp;
  <br />
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Maharashtra
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 10/12/2017
</p>
<p>Perfectly abstracted
</p>
<p>
  <br />
  Nice Paintings and inspired all seen
</p>
  <br />
<p>Astonishing peace of art really inspiring &amp; beautiful. All
  <br />
  the best &quot;Ranjan&quot; from Rani &amp; family
</p>`,
28:`<p>Excellent work , really inspriring and relates
  <br />
  to the usual stuff in everyday life that
  <br />
  goes unnoticed. Kudos to the artist to capture
  <br />
  those emotions and moments on canvas ... !!
</p>
<p>
  <br />
  Very nice and fabulous paintings
  <br />
  The artist has presented minute details
  <br />
  very well.
  <br />
  Pictures of mountains are very
  <br />
  scenic and beautiful.
  <br />
  Well done Ranjan !!!
  <br />
  &nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;Vikalp(10/12/2017)
</p>
<p>My fav &quot;Silent Conversation&quot; Awesome
  <br />
  paintings ; nice work. In &quot;Silent Conversation&quot;
  <br />
  eyes of the man are looking somewhere else like
  <br />
  he is lost in deep thoughts and the woman
  <br />
  also trying to say something.&nbsp;
  <br />
  I am gonna write a poem. Nice inspiration
  <br />
  for me. Thanks a lot.
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Raj K Chandel
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;10/12/17
</p>
<p>
  <br />
  Fabulous painting .....
  <br />
  Appriciate the skills
</p>`,
29:`<p>Loved it Ranjan. Keep up the good works
</p>
<br/>
<p>Very good collection of paintings, loved it
</p>
<p>
  <br />
  Excellent. Village Gathering Class apart !!!
</p>
<p>inspiring
</p>
<p>
  <br />
  A sleeping traveller was really fantastic
  <br />
  Thank you
  <br />
  Keerthi
</p>
<br />
<p>Beautifully done. Snapshots of the various fragments
  <br />
  of the country captured in essance of each
  <br />
  piece of Art.
  <br />
  &nbsp;&nbsp; &nbsp;- Shankar
</p>
<p>Beautiful and Excellent
  <br />
  &nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;Tamil Nadu
</p>
<p>deep thought and awesome work love all the
  <br />
  painting. Shilpi Agrawal
</p>
<p>
  <br />
  Different Ideas captured beautifully
  <br />
  &nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; &nbsp;N K Bansal
</p>`,
30:`<p>Hi Shandil/Surya,
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp;Loved some of your works and the way they
  <br />
  have been rendered !!
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; thanks !&nbsp;
</p>
<p>Love your work with gray shades. lovely art work.
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Cheers!! &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Somya.
</p>
<p>
  <br />
  Diverse choice of themes, Interesting
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; Chinmay
</p>
<p>Every art is an excellent piece of talent
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;-Vin
</p>
<br/>
<p>Wonderful art work, whole heartedly appricite the artists and
  <br />
  all the core focuses of this beautiful place and side walk
  <br />
  Gallery
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; Thank you. best wishes and warm regards
</p>
<p>Chundan Vallam is awesome - &nbsp; Mahalakshmi
</p>
<p>Excellent work Sir, very thoughtful paintings, love all
  <br />
  &nbsp;ur apintings
</p>
<p>Excellent work sir
</p>
<br/>
<p>Amazing work.
</p>`,
31:`<p>
  Very Nice work expecially the village scene is
  <br />
  beautiful
</p>
<br />
<p>
  <br />
  Ultimate work by Ranjan &amp; its beautiful
</p>
<br />
<p>- Realy its beautiful. I am hats off to Ranjan
  <br />
  &nbsp;&nbsp; &nbsp;thankQ your efforts
</p>
<p>
  <br />
  <br />
  <br />
  Great work Surya! Always a pleasure seeing&nbsp;
  <br />
  your creations and unique art forms. Keep going
  <br />
  and best of luck.
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; - Vinay Gupta
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &amp; Shweta Gupta
</p>
<p>Beautiful Work- Liked Launch the best - &nbsp;all best
  <br />
  &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Ratna
</p>
<br/>
<p>Great work of conceptual depiction
</p>
<p>Beautiful
</p>
<p>Beautiful &amp; nostalgic
</p>`,
32:`<p>Great stuff. Minimal and neat.
</p>
<p>lovely Art
  <br />
  &nbsp;
</p>
`
}